import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizBasePopUp,
  WizLabel,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { IWidget, PivotCellEditPopData } from '../../../../../manager/widgets/i-widget';
import { BaselineEngine, EM_ACTION, FeiKeyDef, FIELD_KIND, KEY_KIND, MeasureVO, WidgetLine, WizConstants } from '@wizeoo/akm-compute-lib';
import { ColDef } from 'ag-grid-community';
import { Measure, WidgetConfigurationObj } from '@wizeoo/akm-message-lib';
import { UpdateRequest } from '../../../../../command/core/sync/sync.service';
import { ListFieldGridDatas } from '../../../../../manager/workingdata/listfield.engine';
import { GridOptions } from '@ag-grid-community/core';
import { PivotCellEditor } from './pivot-cell.editor';
import { ToolPivot } from '../../../../tools/tool-pivot.component';
import { Model } from '../../../../../model/model';
import { FreedataValueVO } from '../../../../../vo/core/freedatavalue.vo';
import { FreedataArgsVO } from '../../../../../vo/core/freedataargs.vo';


@Component({
  // popUp d'édition des cellules de type filterKey
  selector: 'pivot-cell-list-edit-pop',
  templateUrl: './pivot-cell-list-edit.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PivotCellListEditPop extends WizBasePopUp {
  @ViewChild('lbTitle', { read: WizLabel, static: false }) lbTitle: WizLabel; // titre de la popUp (fullcode)
  // @ViewChild('lbMeasure', { read: WizLabel, static: false }) lbMeasure: WizLabel; // titre de la mesure (fullcode)
  // @ViewChild('liKey', { read: WizList, static: false }) liKey: WizList; // la liste contenant les valeurs de clés
  @ViewChild('popFilter', { read: FilterComponent }) popFilter: FilterComponent; // filtre des mesures
  @ViewChild('vspKeyMatrix', { read: ToolPivot }) vspKeyMatrix: ToolPivot; // arbre du prototype de step

  /** accesseur avec cast */
  private get popupData(): PivotCellEditPopData {
    return this.datas as PivotCellEditPopData;
  }

  public columns: ColDef[]; // Colonnes du grid
  
  /** composant utilisés par le grid */
  public gridFrameworkComponents = { pivotCellEditor: PivotCellEditor };

  /** la DS de la liste. On recycle le mécanisme d'alimentation des filtres, il marche bien avec freedata et chrono */
  // public mainDS: WizDatasource<WidgetLine> = new WizDatasource<WidgetLine>([])
  //   .setFilter(this.filterFunc.bind(this))
  //   .setSelectionMode('single')
  //   .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
  //   .build();


  public static baseWidth: number = 500;
  public static baseHeight: number = 400;

  public fei: FeiVO = null; // l'instance de FEI manipulée par ce composant
  public widget: IWidget; // accesseur sur le widget
  public line: WidgetLine; // la pl de référence pour update
  public pack: WidgetLine[]; // le pool de line effectif. Prise en compte de l'aggrégat en colonne
  private fkd: FeiKeyDef;
  public measure: Measure;

  private fdv: FreedataValueVO = null;
  private arg: FreedataArgsVO = null;

  public get model(): Model{
    return this.popupData?.widget?.model;
  }

  // configuration, construite par le ListFieldEngine
  public listFieldGridDatas: ListFieldGridDatas = null;

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  public context: WidgetConfigurationObj = null;

  public selectionMode: string = 'none';

  /**
   * objet source FDV / BL
   */
  public mode: string = 'BL'; // BL ou FDV

  show(): void {
    this.widget = this.popupData.widget;
    this.fei = this.widget.fei as FeiVO;
    this.pack = this.popupData.pack;
    
    if(this.popupData.fdv) {
      this.mode = 'FDV';
      this.fdv = this.popupData.fdv;
      this.arg = this.popupData.arg;
    } else {

    }

    if(!!this.popupData.fkd) { // une vraie mesure, ou un fake depuis le ArgRenderer
      this.fkd = this.popupData.fkd;
      this.measure = this.popupData.fkd.measure;
    } else { // fdv depuis fdGrid, il faut créer le fake
      const fakeMeas: MeasureVO = this.model.measureEngine.buildFake();
      fakeMeas.code = this.popupData.arg.code;
      fakeMeas.shortCode = this.popupData.arg.code;
      fakeMeas.mode = WizConstants.MEASURE_MODE_INTERACT; // interact, donc présentée par défaut
      fakeMeas.datakind = FIELD_KIND.LIST; // on veut une liste
      fakeMeas.settings = this.popupData.arg.settings;
      let fakeFkd: FeiKeyDef = BaselineEngine.buildFeiKeyDef(this.widget.fakeFei, KEY_KIND.MEASURE, fakeMeas.source, WizConstants.MEASURE_MODE_INTERACT);
      this.fkd = fakeFkd;
      this.measure = fakeFkd.measure;
    }
   

    // console.log('cellParams', this.params);
    // prise du label du champ d'origine
    this.lbTitle.wizLabel = this.datas.title;

    if(this.mode === 'BL') {
      this.listFieldGridDatas =  this.model.listFieldEngine.buildGridParameters(this.fei, this.fkd, this.pack);
    } else {
      this.listFieldGridDatas =  this.model.listFieldEngine.buildGridParametersForFD(this.fei, this.fkd, this.fdv, this.arg);
    }


    this.popFilter.configure(['shortCode', 'trsLabel'], this.listFieldGridDatas.filter, null).build(); // alimentation du filtre
    this.vspKeyMatrix.feedForList(this.listFieldGridDatas);
    
    // console.log('list pop', this.measure, this.listFieldGridDatas);


    this.addListeners();

    setTimeout(() => {
      this.doFilter(null); // on force le filtre
    }, 0);

  }

  /** configuration de l'agGrid */
  gridOptions: GridOptions = {
    stopEditingWhenCellsLoseFocus: true, // 
    suppressRowClickSelection: true, // pas de sélection directe, on gère nous même
    getRowNodeId: (params) => params?.uk, // ce qui définit la clé : la clé unique de widgetLine
  };

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre des mesures & function
  }

  /**
   * forcer le filtre du grid
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.vspKeyMatrix.forceFilter(this.popFilter.basicValue);
  }


  /** Sauvegarde */
  public save(): void {
    let value: string = null;

    let exist: boolean = false;
    let res: any = {};

    [...this.listFieldGridDatas.valueMap.keys()].forEach(key => {
      if(this.listFieldGridDatas.valueMap.get(key) && Number(this.listFieldGridDatas.valueMap.get(key)) !== 0) {
        exist = true;
        res[key] = this.listFieldGridDatas.valueMap.get(key);
      }
    })

    this.vspKeyMatrix.listControlOnSave(); // contrôle de cohérence

    if(exist) {
      value = JSON.stringify(res);
    } 

    const updates: UpdateRequest = {
      fei: this.fei, 
      line: this.line,
      lines: this.pack, 
      operation: EM_ACTION.UPDATE,
      fkd: this.fkd,
      value,
      doSplit: false
    };

    this.popupData.updates = updates;
    this.popupData.callback(this.popupData); // on appelle la callback avec le pack d'updates

    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    // this.doSaveFlag = false;
    this.hide();
  }

  public hide() {
    WizEventManager.removeListener(this, this.popFilter, WIZ_EVENT_TYPE.FILTER);
    super.hide();
  }

}
